import React, { useEffect, useContext } from 'react';
import { AppContext } from '../../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../../assets/css/buttons.css';
import { SocketContext } from '../../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Flaky as FlakyIcon,
} from '@mui/icons-material/';
import { Box, Button, Typography } from '@mui/material';

function ModalPapirGameFinishedWithoutPrize() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    updateShowModalPapirGameFinishedWithoutPrize,
    updateIsLoadingScreen,
    papirScannedInfo,
    updateShowModalPapirCheckCard,
    updatePapirCardInfo,
  } = useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleGetPapirCardInfo = async (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirCardInfo(data);
      updateShowModalPapirCheckCard(true);
    };

    socket.on('getPapirCardInfo', handleGetPapirCardInfo);
    return () => {
      socket.off('getPapirCardInfo', handleGetPapirCardInfo);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const confirmClose = async () => {
    updateFocusOnMainScreen(true);
    updateShowModalPapirGameFinishedWithoutPrize(false);
  };

  const handleCheckCard = async () => {
    updateIsLoadingScreen(true);
    socket.emit('getPapirCardInfo', {
      bingoName: papirScannedInfo.bingoName,
      gameID: papirScannedInfo.gameID,
      ticketID: papirScannedInfo.ticketID,
    });
  };

  return (
    <div id="react-confirm-alert">
      <div
        className="react-confirm-alert-overlay"
        style={{
          background: 'rgba(3,6,18,0.88)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: 'min(860px, 94vw)',
            borderRadius: '24px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            background:
              'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              height: 70,
              px: '24px',
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.10)',
              background:
                'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{ color: 'white', fontSize: '24px', fontWeight: 900, lineHeight: 1 }}
            >
              {t('sales.papirGameFinishedWithoutPrizeTitle')}
            </Typography>
          </Box>

          {/* Body */}
          <Box sx={{ p: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Box
              sx={{
                borderRadius: '18px',
                border: '1px solid rgba(255,255,255,0.14)',
                background: 'rgba(255,255,255,0.06)',
                p: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                {t('sales.papirGameFinishedWithoutPrizeText1')}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                {t('sales.papirGameFinishedWithoutPrizeText2')}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: '14px' }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => { confirmClose(); }}
                startIcon={<CheckCircleIcon sx={{ fontSize: 28 }} />}
                sx={{
                  height: 76,
                  borderRadius: '16px',
                  bgcolor: '#FFC727',
                  color: '#000',
                  fontWeight: 800,
                  fontSize: 22,
                  textTransform: 'uppercase',
                  boxShadow: '0 12px 32px rgba(255,199,39,0.4)',
                  '&:hover': {
                    bgcolor: '#FFD54F',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 16px 40px rgba(255,199,39,0.55)',
                  },
                  '&:active': { transform: 'translateY(0)' },
                }}
              >
                {t('sales.confirm')}
              </Button>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleCheckCard();
                }}
                startIcon={<FlakyIcon sx={{ fontSize: 28 }} />}
                sx={{
                  height: 76,
                  borderRadius: '16px',
                  bgcolor: 'rgba(255,255,255,0.08)',
                  color: 'rgba(255,255,255,0.75)',
                  fontWeight: 800,
                  fontSize: 22,
                  textTransform: 'uppercase',
                  border: '1px solid rgba(255,255,255,0.14)',
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.14)',
                    transform: 'translateY(-2px)',
                    color: 'white',
                  },
                  '&:active': { transform: 'translateY(0)' },
                }}
              >
                {t('sales.checkCard')}
              </Button>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ModalPapirGameFinishedWithoutPrize;
